import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeIn = ({ children, delay = 0, className = "", y = 28 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "", inView = false }) => {
    const anim = { y: 0 };
    const transition = { duration: 0.9, delay, ease: EASE };
    return (
        <span className={`block overflow-hidden ${className}`}>
            {inView ? (
                <motion.span
                    className="block"
                    initial={{ y: "112%" }}
                    whileInView={anim}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={transition}
                >
                    {children}
                </motion.span>
            ) : (
                <motion.span className="block" initial={{ y: "112%" }} animate={anim} transition={transition}>
                    {children}
                </motion.span>
            )}
        </span>
    );
};

export const Crosshair = ({ className = "" }) => (
    <span aria-hidden className={`absolute font-mono text-white/30 text-sm select-none pointer-events-none ${className}`}>
        +
    </span>
);

export const MonoLabel = ({ children, className = "" }) => (
    <p className={`font-mono text-xs md:text-sm tracking-[0.25em] uppercase text-[#FF5C00] ${className}`}>{children}</p>
);
